module.exports = __webpack_public_path__ + "static/certyfikat_WSK_pol-dcbcd09b661812bb23aa1d1817e87895.pdf";